"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgSync = props => (0, jsx_runtime_1.jsxs)("svg", {
  "data-name": "Regular 1.5px/sync",
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  ...props,
  children: [(0, jsx_runtime_1.jsx)("path", {
    "data-name": "Regular 1.5px/sync background",
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }), (0, jsx_runtime_1.jsxs)("g", {
    fill: "#1c1c1c",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M12 3.75a8.11 8.11 0 016.682 3.495l-2.179-.006a.75.75 0 100 1.5l3.55.01h.45A.75.75 0 0021.25 8V4a.75.75 0 00-1.5 0v2.162A9.6 9.6 0 0012 2.25 9.75 9.75 0 002.25 12a.75.75 0 001.5 0A8.25 8.25 0 0112 3.75z"
    }), (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Union",
      d: "M12 20.25a8.11 8.11 0 01-6.682-3.495l2.179.006a.75.75 0 000-1.5L3.95 15.25h-.448a.75.75 0 00-.752.75v4a.75.75 0 101.5 0v-2.162A9.6 9.6 0 0012 21.75 9.75 9.75 0 0021.75 12a.75.75 0 00-1.5 0A8.25 8.25 0 0112 20.25z"
    })]
  })]
});
exports.default = SvgSync;